import './style.less';
import { keyBy } from 'lodash';

export default function($rootScope, $scope, $log, $state, $timeout, $stateParams, $window, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const courseId = $stateParams.courseId;
  const moduleId = $stateParams.moduleId;
  const params = $stateParams;
  vm.resultsQueried = false;

  vm.stateParams = $stateParams;

  function activate() {
    $log.debug('Self Study Container Loaded');
    vm.loaded = false;
    vm.error = {};

    ApiClass.coursesIdGet({ id: $stateParams.courseId })
      .then(courseResponse => {
        const course = courseResponse ? courseResponse.data.course : {};
        const modules = course.modulesArr;
        const material = course.materials;
        course.handouts = material && material.fileUrls ? material.fileUrls : [];
        vm.course = course;
        vm.index = vm.course.modules.indexOf(moduleId);
        vm.progress = course.progress;
        vm.loaded = true;
        vm.activeModule = moduleId;
        vm.course.moduleHandouts = modules.reduce((obj, module) => {
          obj[module.module_id] = module.pdf;
          return obj;
        }, {});
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/selfStudy/nav/index.js